import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  error: {
    color: 'firebrick',
  },
}));

export default useStyles;
